import "./Faculty.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import Select, { components } from "react-select";
import { AxiosInstance } from "../../../../axios";
// import CategorySubject from "./CategorySubject";
import moment from "moment";
import { validateFaculty } from "./validation";
import { customStyles } from "../../../../pages/customStyles";
import DatePickerSample from "../../DatePicker";
import intlTelInput from "intl-tel-input";
import toast from "react-hot-toast";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";

function NewFaculty() {
  const txtFacFName = useRef(null);
  const txtFacLoca = useRef(null);
  const txtFacLName = useRef(null);
  const txtFacPno = useRef(null);
  const txtFacEmail = useRef(null);
  const txtFacDes = useRef(null);
  const txtFacDjoin = useRef(null);
  const txtFacCate = useRef(null);
  const { facId, userId } = useParams();
  const location = useLocation();
  const { upgrade } = location.state ?? {};
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [fData, setFormData] = useState({
    staff_id: "",
    fname: "",
    lname: "",
    phoneNumber: "",
    phone_code: "+91",
    email: "",
    TechType: facId === "0" || facId === 0 ? 0 : 1,
    designation: "",
    designation_id: "",
    DJoin: "",
    location: "",
    location_id: "",
    is_eligible_class: "",
  });

  const [category, setCategory] = useState([]);
  const [error, setError] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [subject, setSubject] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    // Initialize intl-tel-input on component mount
    const iti = intlTelInput(txtFacPno.current, {
      // Add options as needed, refer to the intl-tel-input documentation
      initialCountry: "in",
      separateDialCode: true,
    });

    txtFacPno.current.addEventListener("countrychange", () => {
      const selectedCountryData = iti.getSelectedCountryData();
      setFormData((prevFields) => ({
        ...prevFields,
        phone_code: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
      }));
    });

    // Clean up on component unmount
    return () => {
      iti.destroy();
    };
  }, []);

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        if (res.data.data.length > 0) {
          const loc = res.data.data
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((item, index) => ({
              value: item.id,
              label: item.name,
            }));
          setLocations(loc);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleChangeCuDate = (dates, name) => {
    const dateSam = moment(dates).format("DD/MM/YYYY");
    setFormData((prevState) => ({
      ...prevState,
      [name]: dateSam,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  useEffect(() => {
    const teachId = parseInt(facId);
    AxiosInstance.get(`api/all/getDesignation/${teachId}/0`)
      .then((res) => {
        const designation = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.id,
            label: item.name,
          }));
        setDesignation(designation);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    if (userId) {
      AxiosInstance.post("api/staff/view", { user_id: userId })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.staff_type === 3) {
              setFormData({
                staff_id: res.data.data.staff_id,
                fname: res.data.data.first_name,
                lname: res.data.data.last_name,
                phoneNumber: res.data.data.mobile_no,
                phone_code: res.data.data.country_code,
                email: res.data.data.email,
                is_eligible_class: res.data.data.is_eligible_class,
                TechType: res.data.data.staff_type,
                designation_id: "",
                designation: "",
                DJoin: "",
                location: "",
                location_id: "",
              });
            } else {
              setFormData({
                staff_id: res.data.data.staff_id,
                fname: res.data.data.first_name,
                lname: res.data.data.last_name,
                phoneNumber: res.data.data.mobile_no,
                phone_code: res.data.data.country_code,
                email: res.data.data.email,
                is_eligible_class: res.data.data.is_eligible_class,
                TechType: res.data.data.staff_type,
                designation_id: res.data.data.designation_id,
                designation: res.data.data.designation,
                DJoin: moment(res.data.data.aiasa_doj).format("DD/MM/YYYY"),
                location: res.data.data.staff_loc_name,
                location_id: res.data.data.staff_loc_id,
              });
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [userId]);

  // ---------- handler ---------------
  const handleSelectCH = (option, field) => {
    /* When the user clears the select, option === null */
    if (!option) {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}_id`]: "",
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      /* Save name (label) and id (value) separately */
      [field]: option.label,
      [`${field}_id`]: option.value,
    }));

    setError((prev) => ({ ...prev, [field]: "" }));
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;

    if (name === "category") {
      if (checked) {
        setCategory([...category, value]);
      } else {
        setCategory(category.filter((item) => item !== value));
      }
      setError({
        ...error,
        [name]: "",
      });
    } else if (name === "phoneNumber") {
      if (value.length === 10 || value.length === 0) {
        setFormData((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setFormData((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "staffTechType") {
      setFormData((prevList) => ({
        ...prevList,
        is_eligible_class: value === "0" ? 0 : 1,
      }));
      setError({
        ...error,
        TechType: "",
        jobType: "",
      });
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  const handleSubmit = (e) => {
    const useref_validation = {
      firstName: txtFacFName.current,
      lastName: txtFacLName.current,
      phoneNumber: txtFacPno.current,
      email: txtFacEmail.current,
      designation: txtFacDes.current,
      dateOfJoining: txtFacDjoin.current,
      category: txtFacCate.current,
      location: txtFacLoca.current,
    };
    const errors = validateFaculty(
      fData,
      0,
      category,
      subject,
      facId,
      useref_validation
    );
    if (Object.keys(errors).length === 0) {
      try {
        if (userId) {
          const newData = [];
          const newDataPks = [];
          const catses = [];
          const mappedDatas = {
            department_id: null,
            designation_id: fData.designation_id,
            department: null,
            exp_designation: fData.designation,
          };
          const updateStaff = {
            user_id: userId,
            first_name: fData.fname,
            last_name: fData.lname,
            mobile_no: fData.phoneNumber,
            country_code: fData.phone_code,
            email: fData.email,
            staff_type: fData.TechType,
            job_info: [mappedDatas],
            category: null,
            designation_id: fData.designation_id,
            designation: fData.designation,
            is_eligible_class: fData.is_eligible_class,
            subject: null,
            subject_pk: null,
            aiasa_doj: fData.DJoin
              ? fData.DJoin.split("/").reverse().join("-")
              : "",

            location: fData.location_id,
            created_by: userid,
            updated_by: userid,
          };

          if (upgrade !== null && upgrade !== "") {
            // Add the upgrade property to the updateStaff object
            updateStaff.upgrade = upgrade;
          }

          AxiosInstance.post("api/staff/register/edit", updateStaff)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                handleClose();
                navigateToPreviousScreen();
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          if (facId === "0" || facId === 0) {
            const newData = [];
            const newDataPk = [];
            subject.forEach((item) => {
              item.optionSelected.forEach((option) => {
                newData.push({
                  category: item.category,
                  subject: option.value.trim(),
                  subject_pk: option.pk,
                });
                newDataPk.push(option.pk);
              });
            });
            const cates = subject.map((item) => item.category);

            const createStaff = {
              first_name: fData.fname,
              last_name: fData.lname,
              mobile_no: fData.phoneNumber,
              email: fData.email,
              staff_type: fData.TechType,
              country_code: fData.phone_code,
              category: cates,
              designation_id: fData.designation_id,
              designation: fData.designation,
              is_eligible_class: 1,
              subject: newData,
              subject_pk: newDataPk.length > 0 ? newDataPk : null,
              aiasa_doj: fData.DJoin
                ? fData.DJoin.split("/").reverse().join("-")
                : "",
              location: fData.location_id,
              created_by: userid,
            };
            AxiosInstance.post("api/user/register/staff", createStaff)
              .then((res) => {
                if (res.data.status === true) {
                  toast.success(res.data.message);
                  handleClose();
                  navigateToPreviousScreen();
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          } else {
            const createStaff = {
              first_name: fData.fname,
              last_name: fData.lname,
              mobile_no: fData.phoneNumber,
              country_code: fData.phone_code,
              email: fData.email,
              staff_type: 1,
              category: null,
              designation_id: fData.designation_id,
              designation: fData.designation,
              is_eligible_class: fData.is_eligible_class,
              subject: null,
              subject_pk: null,
              aiasa_doj: fData.DJoin
                ? fData.DJoin.split("/").reverse().join("-")
                : "",
              location: fData.location_id,
              created_by: userid,
            };
            AxiosInstance.post("api/user/register/staff", createStaff)
              .then((res) => {
                if (res.data.status === true) {
                  toast.success(res.data.message);
                  handleClose();
                  navigateToPreviousScreen();
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };

  const CheckValidation = () => {
    const useref_validation = {
      firstName: txtFacFName.current,
      lastName: txtFacLName.current,
      phoneNumber: txtFacPno.current,
      email: txtFacEmail.current,
      designation: txtFacDes.current,
      dateOfJoining: txtFacDjoin.current,
      category: txtFacCate.current,
      location: txtFacLoca.current,
    };
    const errors = validateFaculty(
      fData,
      0,
      category,
      subject,
      facId,
      useref_validation
    );

    if (Object.keys(errors).length === 0) {
      handleShow();
    } else {
      setError(errors);
    }
  };

  return (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Confirmation"
          message={`Are you sure you want to send the invitation to this ${
            facId == 0 ? "faculty?" : "staff?"
          }`}
          onConfirm={handleSubmit}
          onCancel={handleClose}
          confirmLable={"Send Invitation"}
        />
      )}
      <div className=" Faculty BathHeader global_container">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">
              {upgrade === 1
                ? "Upgrade to Teaching Faculty"
                : userId
                ? facId == 0
                  ? "Edit Faculty Profile"
                  : "Edit Staff Profile"
                : facId == 0
                ? "Add New Faculty"
                : "Add New Staff"}
            </h2>
          </div>

          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  to={
                    upgrade === 1
                      ? `/Faculties/PanelMember/${userId}/${fData.staff_id}/4/3`
                      : `/Faculties/${facId == 0 ? 1 : 2}`
                  }
                  className="secondaryButton"
                  variant="secondary"
                >
                  {upgrade === 1
                    ? "Back to View Panel Member"
                    : facId == 0
                    ? "Back to Faculties"
                    : "Back to Staff"}
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={CheckValidation}
                  className="primaryButton text-center"
                  variant="primary"
                >
                  {upgrade === 1
                    ? "Upgrade to Teaching Faculty"
                    : userId
                    ? facId == 0
                      ? "Save Faculty Profile"
                      : "Save Staff Profile"
                    : "Send Invitation Link"}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Basic Details</legend>
            <form className="row g-3">
              <div class="col-md-6">
                <label for="CourseName" class="form-label confirm_value ">
                  First Name
                </label>
                <input
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  ref={txtFacFName}
                  type="text"
                  id="fname"
                  name="fname"
                  value={fData.fname}
                  onChange={handleChange}
                  placeholder="Enter the First Name"
                  required
                />
                {error.fname && (
                  <small className="error_message">{error.fname}</small>
                )}
              </div>
              <div className="col-md-6">
                <label for="AAdmissionType" class={"form-label confirm_value "}>
                  Last Name
                </label>
                <input
                  ref={txtFacLName}
                  type="text"
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  id="lname"
                  name="lname"
                  value={fData.lname}
                  onChange={handleChange}
                  placeholder="Enter the Last Name"
                  required
                />
                {error.lname && (
                  <small className="error_message">{error.lname}</small>
                )}
              </div>

              <div class="col-md-6">
                <label for="Category" class={"form-label confirm_value "}>
                  Phone Number
                </label>
                <input
                  ref={txtFacPno}
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  type="number"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Enter the phone number"
                  value={fData.phoneNumber}
                  onChange={handleChange}
                  required
                  minLength={10}
                  maxLength={10}
                />
                {error.phoneNumber && (
                  <small className="error_message">{error.phoneNumber}</small>
                )}
              </div>
              <div class="col-md-6">
                <label for="CourseGrouping" class={"form-label confirm_value "}>
                  Email ID
                </label>
                <input
                  ref={txtFacEmail}
                  type="email"
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  id="email"
                  name="email"
                  disabled={userId ? true : false}
                  value={fData.email}
                  onChange={handleChange}
                  placeholder="Enter the Email ID"
                  required
                />
                {error.email && (
                  <small className="error_message">{error.email}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Current Job Info</legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label
                  htmlFor="CourseName"
                  className="form-label confirm_value"
                >
                  Job Type
                </label>

                <div className="d-flex gap-4 align-items-center">
                  {fData.TechType === "0" || facId === "0" || facId === 0 ? (
                    <>
                      <div className=" d-flex align-items-center gap-2">
                        <input
                          className="checkbox_radio"
                          type="radio"
                          name="TechType"
                          id="Teaching"
                          value="0"
                          style={{ marginTop: 0, marginRight: 0 }}
                          checked={
                            fData.TechType === "0" ||
                            facId === "0" ||
                            facId === 0
                          }
                          disabled={facId === "1" || facId === 1}
                          onChange={handleChange}
                        />
                        <label className=" confirm_value" htmlFor="Teaching">
                          Teaching
                        </label>
                      </div>

                      <div className=" d-flex align-items-center gap-2">
                        <input
                          className="checkbox_radio"
                          type="radio"
                          name="TechType"
                          id="NonTeaching"
                          value="1"
                          style={{ marginTop: 0, marginRight: 0 }}
                          checked={
                            fData.TechType === "1" ||
                            facId === "1" ||
                            facId === 1
                          }
                          disabled={facId === "0" || facId === 0}
                          onChange={handleChange}
                        />
                        <label className=" confirm_value" htmlFor="NonTeaching">
                          Non Teaching
                        </label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className=" d-flex align-items-center gap-2">
                        <input
                          className="checkbox_radio"
                          type="radio"
                          name="staffTechType"
                          id="Teaching"
                          value="1"
                          style={{ marginTop: 0, marginRight: 0 }}
                          checked={
                            fData.is_eligible_class === "1" ||
                            fData.is_eligible_class === 1
                          }
                          onChange={handleChange}
                        />
                        <label className="confirm_value" htmlFor="Teaching">
                          Teaching
                        </label>
                      </div>

                      <div className=" d-flex align-items-center gap-2">
                        <input
                          className="checkbox_radio"
                          type="radio"
                          name="staffTechType"
                          id="NonTeaching"
                          value="0"
                          style={{ marginTop: 0, marginRight: 0 }}
                          checked={
                            fData.is_eligible_class === "0" ||
                            fData.is_eligible_class === 0
                          }
                          onChange={handleChange}
                        />
                        <label className="confirm_value" htmlFor="NonTeaching">
                          Non Teaching
                        </label>
                      </div>
                    </>
                  )}
                </div>

                {error.jobType && (
                  <small className="error_message">{error.jobType}</small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="AAdmissionType"
                  className="form-label confirm_value"
                >
                  Designation
                </label>
                <Select
                  className={`shadow-none input-font-size margin-left-zero mt-2`}
                  ref={txtFacDes}
                  id="designation"
                  name="designation"
                  value={
                    fData.designation_id
                      ? {
                          value: fData.designation_id,
                          label: fData.designation,
                        }
                      : null
                  }
                  onChange={(option) => handleSelectCH(option, "designation")}
                  options={designation
                    .filter((item) => item && item.label)
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  isSearchable={true}
                  placeholder="Select an designation"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                />

                {error.designation && (
                  <small className="error_message">{error.designation}</small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="AAdmissionType"
                  className="form-label confirm_value"
                >
                  Date of Joining
                </label>
                <DatePickerSample
                  txtAdMDob={txtFacDjoin}
                  name={"DJoin"}
                  handleChange={handleChangeCuDate}
                  fieldInput={fData.DJoin}
                />
                {error.DJoin && (
                  <small className="error_message">{error.DJoin}</small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="AAdmissionType"
                  className="form-label confirm_value"
                >
                  Branch Location
                </label>

                <Select
                  // style={{ marginLeft: 0 }}
                  className={`shadow-none input-font-size`}
                  ref={txtFacLoca}
                  id="location"
                  name="location"
                  value={
                    fData.location_id
                      ? {
                          value: fData.location_id,
                          label: fData.location,
                        }
                      : null
                  }
                  onChange={(option) => handleSelectCH(option, "location")}
                  options={locations
                    .filter((item) => item && item.label)
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  isSearchable={true}
                  placeholder="Select a location"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                />

                {error.location && (
                  <small className="error_message">{error.location}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>

        <div className="row">
          <div className="col-md-6 col-12 ms-auto ListBtn">
            <ul className="List-Button d-flex justify-content-end">
              <li className="ListBtnItems">
                <Link
                  to={
                    upgrade === 1
                      ? `/Faculties/PanelMember/${userId}/${fData.staff_id}/4`
                      : `/Faculties/${facId == 0 ? 1 : 2}`
                  }
                  className="secondaryButton"
                  variant="secondary"
                >
                  {upgrade === 1
                    ? "Back to View Panel Member"
                    : facId == 0
                    ? "Back to Faculties"
                    : "Back to Staff"}
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={CheckValidation}
                  className="primaryButton text-center"
                  variant="primary"
                >
                  {upgrade === 1
                    ? "Upgrade to Teaching Faculty"
                    : userId
                    ? facId == 0
                      ? "Save Faculty Profile"
                      : "Save Staff Profile"
                    : "Send Invitation Link"}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
export default NewFaculty;
